export const POPUP_FEATURE_TEXT_MAP = {
	'resumes.edit' : {
		title: 'Get seen, get hired.',
		description: 'Resumes getting ignored? Start landing interviews with ResumAI.',
	},
	'resume-tool' : {
		title: 'Get seen, get hired.',
		description: 'Resumes getting ignored? Start landing interviews with ResumAI.',
	},
	community: {
		title: 'Proof, not promises.',
		description: 'Want to see real resumes that landed interviews? Get access now.'
	},
	'job-board-search' : {
		title: 'A smarter job board.',
		description: 'Still manually tailoring your resumes? Unlock your faster, easier job search.'
	},
	'cover-letters.index': {
		title: 'Sell your story in seconds.',
		description: 'Tailor your cover letters with one click.  Made easy with CoverLetterAI.'
	},
	'interview-ai': {
		title: 'Practice now, not later.',
		description: 'The best answers aren’t improvised, they’re practiced. Why wait?'
	},
	'interview-ai-create': {
		title: 'Practice now, not later.',
		description: 'The best answers aren’t improvised, they’re practiced. Why wait?'
	},
	'networking-tool': {
		title: 'Networking lands jobs.',
		description: 'Up to 80% of jobs are filled by networking. Start with our help now.'
	},
};
